import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 32EF248B-1462-486E-AEF1-A0ED29670568
 * name flag-plus-outline
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/flag-plus-outline.svg
 * tags
 */
export const FlagPlusOutlineIcon = createSvgIcon(<><path d="M13 16L12.6 14H7V21H5V4H14L14.4 6H20V13.09C19.67 13.04 19.34 13 19 13C18.66 13 18.33 13.04 18 13.09V8H12.76L12.36 6H7V12H14.24L14.64 14H15.69C14.92 14.5 14.27 15.2 13.81 16H13M18 15V18H15V20H18V23H20V20H23V18H20V15H18Z" /></>, 'FlagPlusOutlineIcon');
export default FlagPlusOutlineIcon